import AUDIO_INSTRUCTIONS from '../constants/audio';

import wrOpeningInstruction from '../sounds/rct_opening.mp3';
import wrReadyInstruction from '../sounds/rct_accuracy_ready.mp3';
import wrQuestionsInstruction from '../sounds/rct_accuracy_question_instruction.mp3';
import wrPracticeStartInstruction from '../sounds/rct_accuracy_practice_start.mp3';
import wrPracticeCorrectResponse from '../sounds/rct_accuracy_practice_correct.mp3';
import wrPracticeFirstIncorrect from '../sounds/rct_accuracy_practice_incorrect_1.mp3';
import wrPracticeSecondIncorrect from '../sounds/rct_accuracy_practice_incorrect_2.mp3';
import wrAnswerHot from '../sounds/rct_accuracy_model_hot.mp3';
import wrAnswerPan from '../sounds/rct_accuracy_model_pan.mp3';
import wrAnswerRib from '../sounds/rct_accuracy_model_rib.mp3';
import avatarStartModel from '../sounds/rct_accuracy_model_instruction.mp3';
import avatarInstructionModel from '../sounds/rct_accuracy_model_click_correct.mp3';
import avatarDirectionInstruction from '../sounds/rct_accuracy_direction.mp3';

const WR_AUDIO_INSTRUCTIONS = {
    wrOpeningInstruction,
    wrQuestionsInstruction,
    wrReadyInstruction,
    avatarAnswers: [wrAnswerHot, wrAnswerPan, wrAnswerRib],
    avatarDirectionInstruction,
    avatarInstructionModel,
    avatarStart: wrPracticeStartInstruction,
    avatarStartModel,
    clickOk: AUDIO_INSTRUCTIONS.clickOk,
    commonReadyInstruction: AUDIO_INSTRUCTIONS.commonReadyInstruction,
    correctResponseInstruction: wrPracticeCorrectResponse,
    firstIncorrectInstruction: wrPracticeFirstIncorrect,
    secondIncorrectInstruction: wrPracticeSecondIncorrect,
};

export default WR_AUDIO_INSTRUCTIONS;
